export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  DELIVERED: 'delivered',
  READ: 'read',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
};

export const CONVERSATION_STATUS = {
  OPEN: 'open',
  RESOLVED: 'resolved',
  PENDING: 'pending',
  SNOOZED: 'snoozed',
};

export const CONVERSATION_PRIORITY = {
  URGENT: 'urgent',
  HIGH: 'high',
  LOW: 'low',
  MEDIUM: 'medium',
};

export const CONVERSATION_PRIORITY_ORDER = {
  urgent: 4,
  high: 3,
  medium: 2,
  low: 1,
};

// Size in mega bytes
export const MAXIMUM_FILE_UPLOAD_SIZE = 40;
export const MAXIMUM_FILE_UPLOAD_SIZE_TWILIO_SMS_CHANNEL = 5;

// Maximum number of attachments allowed per message
export const MAXIMUM_ATTACHMENTS_COUNT = 10;

export const MAXIMUM_FILE_UPLOAD_SIZE_FACEBOOK = 25;

// Instagram file size limits in megabytes
export const MAXIMUM_FILE_UPLOAD_SIZE_INSTAGRAM_IMAGE = 8;
export const MAXIMUM_FILE_UPLOAD_SIZE_INSTAGRAM_MEDIA = 25;

export const ALLOWED_FILE_TYPES =
  '.jpg,.jpeg,.png,.webp,.bmp,.gif,.heic,' +
  '.mp3,.wav,.aac,.flac,.m4a,' +
  '.mp4,.mov,' +
  '.doc,.docx,.xls,.xlsx,.ppt,.pptx,' +
  '.pdf,.txt,.csv';

export const ALLOWED_FILE_TYPES_FOR_TWILIO_WHATSAPP =
  '.png,.jpeg,.jpg,.mp3,.mp4,.pdf';

// https://developers.line.biz/en/reference/messaging-api/#image-message, https://developers.line.biz/en/reference/messaging-api/#video-message
export const ALLOWED_FILE_TYPES_FOR_LINE = '.png,.jpeg,.jpg,.mp4';

// Instagram supported formats based on official documentation
export const INSTAGRAM_IMAGE_TYPES = '.png,.jpeg,.jpg,.gif';
export const INSTAGRAM_AUDIO_TYPES = '.aac,.m4a,.wav,.mp4,.mp3';
export const INSTAGRAM_VIDEO_TYPES = '.mp4,.ogg,.avi,.mov,.webm';

export const ALLOWED_FILE_TYPES_FOR_INSTAGRAM =
  INSTAGRAM_IMAGE_TYPES +
  ',' +
  INSTAGRAM_AUDIO_TYPES +
  ',' +
  INSTAGRAM_VIDEO_TYPES;

export const ALLOWED_FILE_TYPES_FOR_OFFICIAL = '.png,.jpeg,.jpg,.gif,.mp3,.mp4';

// 企业微信客服支持的文件类型
// 图片：JPG, PNG
// 语音：AMR
// 视频：MP4
// 文件：所有类型（通过 file 类型上传）
export const ALLOWED_FILE_TYPES_FOR_COMPANY =
  '.jpg,.jpeg,.png,' + // 图片
  '.mp3,' + // 语音
  '.mp4,' + // 视频
  '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt,.csv'; // 普通文件

// 企业微信客服文件大小限制（单位：MB）
export const MAXIMUM_FILE_UPLOAD_SIZE_COMPANY_IMAGE = 2; // 图片 2MB
export const MAXIMUM_FILE_UPLOAD_SIZE_COMPANY_VOICE = 2; // 语音 2MB
export const MAXIMUM_FILE_UPLOAD_SIZE_COMPANY_VIDEO = 10; // 视频 10MB
export const MAXIMUM_FILE_UPLOAD_SIZE_COMPANY_FILE = 20; // 普通文件 20MB

export const CSAT_RATINGS = [
  {
    key: 'disappointed',
    translationKey: 'CSAT.RATINGS.POOR',
    emoji: '😞',
    message: '极差',
    value: 1,
    color: '#FDAD2A',
  },
  {
    key: 'expressionless',
    translationKey: 'CSAT.RATINGS.FAIR',
    emoji: '😑',
    message: '差',
    value: 2,
    color: '#FFC532',
  },
  {
    key: 'neutral',
    translationKey: 'CSAT.RATINGS.AVERAGE',
    emoji: '😐',
    message: '一般',
    value: 3,
    color: '#FCEC56',
  },
  {
    key: 'grinning',
    translationKey: 'CSAT.RATINGS.GOOD',
    emoji: '😀',
    message: '好',
    value: 4,
    color: '#6FD86F',
  },
  {
    key: 'smiling',
    emoji: '😍',
    translationKey: 'CSAT.RATINGS.EXCELLENT',
    message: '极好',
    value: 5,
    color: '#44CE4B',
  },
];

export const AUDIO_FORMATS = {
  WEBM: 'audio/webm',
  OGG: 'audio/ogg',
  MP3: 'audio/mp3',
  WAV: 'audio/wav',
};

export const MESSAGE_VARIABLES = [
  {
    label: 'Conversation Id',
    key: 'conversation.id',
  },
  {
    label: 'Contact Id',
    key: 'contact.id',
  },
  {
    label: 'Contact name',
    key: 'contact.name',
  },
  {
    label: 'Contact first name',
    key: 'contact.first_name',
  },
  {
    label: 'Contact last name',
    key: 'contact.last_name',
  },
  {
    label: 'Contact email',
    key: 'contact.email',
  },
  {
    label: 'Contact phone',
    key: 'contact.phone',
  },
  {
    label: 'Agent name',
    key: 'agent.name',
  },
  {
    label: 'Agent first name',
    key: 'agent.first_name',
  },
  {
    label: 'Agent last name',
    key: 'agent.last_name',
  },
  {
    label: 'Agent email',
    key: 'agent.email',
  },
];

export const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones-sound-wave',
  video: 'video',
  file: 'document',
  location: 'location',
  fallback: 'link',
};
